import BasicFormCheckbox from '../../Components/BasicFormCheckbox/BasicFormCheckbox';
import BasicFormLabel from '../../Components/BasicFormLabel/BasicFormLabel';
import BasicFormInquiry from '../../Components/BasicFormInquiry/BasicFormInquiry';
import BasicFormComment from '../../Components/BasicFormComment/BasicFormComment';
import BasicFormInputs from '../BasicFormInputs/BasicFormInputs';
import BasicFormInput from '../../Components/BasicFormInput/BasicFormInput';
import classesCss from './BasicDonateForm.module.css';
import americanexpress from '../../Images/icons8-american-express-48.png';
import discover from '../../Images/icons8-discover-48.png';
import mastercard from '../../Images/icons8-mastercard-48.png';
import visa from '../../Images/icons8-visa-48.png';
import creditcard from '../../Images/icons8-credit-card-58.png';
import {useEffect} from 'react';

const BasicDonateForm = ({paymentType,
	donationAmount,
	register,
	css="",
	handleCardCheckout=()=>{},
	loading=false,
	cardCheckout=false,
	handleSubmit=()=>{},
	executePaypal=()=>{},
	submitForm=()=>{}}) => {

	return (
		<form className={`grid donate__basicForm items-center h-full w-full ${css}`}
			id="my-sample-form"
			method="post"
			onSubmit={handleSubmit(submitForm)}>
			<BasicFormLabel text={"Your Information"}
							sub={true}
							required={true}
							css={classesCss.basicFormLabel}/>
			<div className={"h-full w-full grid grid-rows-2 gap-y-2.5"}>
				<BasicFormInputs labels={["First Name", "Last Name"]}
								 register={register}
								 css={`${classesCss.basicFormInputs} ${classesCss.formInput}`}/>
				<BasicFormCheckbox text={"Maintain Anonymous"}/>
			</div>
			<BasicFormInput label={"Email"} css={`${classesCss.formInput}`} register={register}/>
			<BasicFormInput label={"Leave your regards"}
				 required={false}
				 register={register}
				 area={true}
				 css={`${classesCss.formInput} ${classesCss.regards}`}/>
			 <div className={`grid grid-cols-2 items-center paymentSectionDonate self-start h-full border-t-2 border-t-gray-200 ${cardCheckout ? 'border-b-gray-200 border-b-2' : ''}`}>
				<div className={"grid grid-rows-2 items-center donateCenter"}>
					<div>
						<p>{paymentType}</p>
						<p>{`$${donationAmount} USD`}</p>
					</div>
					<div className={"flex justify-start items-start"}>
						<BasicFormCheckbox text={"I'd like to cover fees"}/>
					</div>
				</div>
				<div className={"grid grid-rows-2 items-center"}>
					<div className={`flex justify-center items-center ${classesCss.paymentButton}`} onClick={executePaypal}>
						<div id="paypal-button" className={`${classesCss.paypalButton} ${loading ? 'hidden' : ''}`}></div>
						<img src={require("../../Images/89.gif")} className={`h-[32px] mb-[10px] ${loading ? 'block' : 'hidden'}`}/>
					</div>
					<div className={`flex justify-center items-center ${classesCss.paymentButton}`} onClick={handleCardCheckout}>
						<div className={classesCss.creditCardBtn}>
							<img src={mastercard} height={"auto"} width={"32px"}/>
							<img src={visa} height={"auto"} width={"32px"}/>
							<img src={discover} height={"auto"} width={"32px"}/>
							<img src={americanexpress} height={"auto"} width={"32px"}/>
						</div>
					</div>
				</div>
			</div>
			{
				cardCheckout ?
				<div className={"self-start grid h-full grid-rows-[repeat(9,100px)] items-center cardForm"}>
					<BasicFormLabel text={"Payment Details"}
									sub={true}
									required={true}
									css={classesCss.basicFormLabel}/>
					<div className={classesCss.creditCardFormInputs}>
						<img src={creditcard} width={"30px"} height={"30px"}/>
						<div id="card-number"></div>
						<div id="expiration-date"></div>
						<div id="cvv"></div>
					</div>
					<BasicFormInputs labels={["Owner First Name", "Owner Last Name"]}
									 register={register}
									 css={`${classesCss.basicFormInputs} ${classesCss.formInput}`}/>
					 <BasicFormInput
						 label={"Country"}
						 css={`${classesCss.formInput}`}
						 dropdown={true}
						 options={["USA", "Peru"]}
						 register={register}/>
					<BasicFormInput
						label={"Address"}
						css={`${classesCss.formInput}`}
						register={register}/>
					<BasicFormInput label={"Address 2"}
						required={false}
						register={register}
						css={`${classesCss.formInput}`}
						/>
					<BasicFormInput
						label={"City"}
						css={`${classesCss.formInput}`}
						register={register}/>
					<BasicFormInputs labels={["State", "Zip"]}
									 register={register}
									 css={`${classesCss.basicFormInputs} ${classesCss.formInput}`}/>
					<div className={"flex self-center justify-around pr-12 pl-12 mt-7 flex-wrap items-center"}>
					 	<button type={"submit"}
							className={"pl-7 pr-7 pt-2 pb-2 bg-orange-500 rounded text-white uppercase"}>
							Give Now
						</button>
						<div>
							<p>One-time donation</p>
							<p>{`$${donationAmount} USD`}</p>
						</div>
					</div>
				</div> : null
			}
		</form>
	);
};

export default BasicDonateForm;
